import AustraliaFlag from "../assets/Austrailia.png";
import UsaFlag from "../assets/USA.png";
import EuroFlag from "../assets/Euro.png";
import ChinaFlag from "../assets/China.png";
import CanadaFlag from "../assets/images/canadaflag.png";
import PakistanFlag from "../assets/images/pakistan.png";
import IndiaFlag from "../assets/images/indiaflag.svg";
import UkFlag from "../assets/images/ukflag.png";
import HongKongFlag from "../assets/images/hongkongflag.png";
import JapanFlag from "../assets/images/japanflag.png";
import NewZealandFlag from "../assets/images/newzelandflag.png";
import SingaporeFlag from "../assets/images/singaporeflag.png";

export const DASHBOARD_CURRENCY_ORDER = ["AUD", "USD", "EUR", "CNY", "CAD", "PKR", "INR"];

export const CURRENCY_NAME = {
  AUD: "Australian Dollar",
  USD: "United States Dollar",
  EUR: "Euro",
  CNY: "Chinese Yuan",
  CAD: "Canadian Dollar",
  PKR: "Pakistani Rupee",
  INR: "Indian Rupee",
  GBP: "British Pound",
};

export const CURRENCY_SYMBOL = {
  AUD: "$",
  USD: "$",
  EUR: "€",
  CNY: "¥",
  CAD: "$",
  PKR: "₨",
  INR: "₹",
  GBP: "£",
};

/**
 * The flags we actually have artwork for.
 *
 * This is the only such map in the app. Several components used to carry their
 * own copy, each missing different currencies and each falling back to the
 * Australian flag, which is why a PKR, CNY or INR wallet showed an Australian
 * flag on the Cards screen.
 */
export const CURRENCY_FLAG = {
  AUD: AustraliaFlag,
  USD: UsaFlag,
  EUR: EuroFlag,
  CNY: ChinaFlag,
  CAD: CanadaFlag,
  PKR: PakistanFlag,
  INR: IndiaFlag,
  GBP: UkFlag,
  HKD: HongKongFlag,
  JPY: JapanFlag,
  NZD: NewZealandFlag,
  SGD: SingaporeFlag,
};

/**
 * The flag for a currency, or null when we have no artwork for it.
 *
 * Null on purpose: 40 currencies are active and only 12 have a flag, so a
 * default was always going to be needed. A *wrong* flag is worse than none
 * telling someone their Pakistani rupee wallet is Australian is a mistake
 * they might act on. Callers render the currency code instead; CurrencyFlag
 * does that for you.
 */
export const flagFor = (currency) => CURRENCY_FLAG[String(currency || "").toUpperCase()] || null;

export const CURRENCY_LOCATION = {
  AUD: "Australia",
  USD: "United States",
  EUR: "Eurozone",
  CNY: "China",
  CAD: "Canada",
  PKR: "Pakistan",
  INR: "India",
  GBP: "United Kingdom",
};

export const formatCurrencyAmount = (amount, currency) =>
  `${CURRENCY_SYMBOL[currency] || ""} ${Number(amount || 0).toLocaleString(
    undefined,
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  )}`;

export const sortByDashboardCurrencyOrder = (accounts = []) =>
  [...accounts].sort((a, b) => {
    const ai = DASHBOARD_CURRENCY_ORDER.indexOf(a.currency);
    const bi = DASHBOARD_CURRENCY_ORDER.indexOf(b.currency);
    if (ai !== -1 || bi !== -1) {
      return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
    }
    return String(a.currency).localeCompare(String(b.currency));
  });
